import {useEffect, useState} from 'react';

type breakpoint = {
    isMobile: boolean;
    isTablet: boolean;
    isNetbook: boolean;
    isNotebook: boolean;
    isDesktop: boolean;
    isDesktop2560: boolean;
    isLessNoteBook: boolean;
}

function getBreakpoint(width: number): breakpoint {
    let isMobile = false,
        isTablet = false,
        isNetbook = false,
        isNotebook = false,
        isDesktop = false,
        isDesktop2560 = false;
    if (width < 822) {
        isMobile = true;
    } else if (width < 960) {
        isTablet = true;
    } else if (width < 1280) {
        isNetbook = true;
    } else if (width < 1920) {
        isNotebook = true;
    } else if (width < 2560) {
        isDesktop = true;
    } else {
        isDesktop2560 = true;
    }
    const isLessNoteBook = isMobile || isTablet || isNetbook;
    return {isMobile, isTablet, isNetbook, isNotebook, isDesktop, isDesktop2560, isLessNoteBook};
}

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export function useBreakpoints(): breakpoint {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return getBreakpoint(windowDimensions.width);
}
